import React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';

import { Txt, TxtProps } from './Txt';
import { theme } from 'lib/theme';

type PillProps = {
  label: React.ReactNode;
  backgroundColor: string;
  textColor?: string;
  style?: StyleProp<ViewStyle>;
  textProps?: TxtProps;
};

export const Pill: React.FC<PillProps> = ({
  label,
  backgroundColor,
  textColor = theme.colors.white,
  style,
  textProps,
}) => (
  <View
    style={[
      {
        backgroundColor,
        borderRadius: 100,
        paddingHorizontal: theme.paddingVerticalQuarter,
        paddingVertical: theme.paddingVerticalQuarter / 2,
        alignItems: 'center',
        justifyContent: 'center',
      },
      style,
    ]}
  >
    <Txt
      {...textProps}
      style={[
        {
          color: textColor,
          textAlign: 'center',
          fontWeight: 'bold',
        },
        textProps?.style,
      ]}
    >
      {label}
    </Txt>
  </View>
);
